var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#666"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 35,
    r: 8,
    fill: "#666"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 62,
    r: 8,
    fill: "#666"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 8,
    r: 8,
    fill: "#666"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 8,
    fill: "#666"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 62,
    r: 8,
    fill: "#666"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 8,
    r: 8,
    fill: "#666"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 35,
    r: 8,
    fill: "#666"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 8,
    fill: "#666"
  })));
};
export default SvgMove;